// Module
var code = `<div class="logo"> <a href="/"> JustBank </a> </div>`;
// Exports
export default code;